export const dateOptionsLong = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

export const dateOptionsMid = {  year: 'numeric', month: 'long', day: 'numeric' };

export const dateOptionsMidTime = {  year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };

export const dateOptionsShort = { year: 'numeric', month: 'short', day: 'numeric' };